import { BRAND_URLS, BRAND_SVGS, LOGO_CLASS_NAMES, FISHERMAN_BRAND_URL, FISHERMAN_BRAND_SVG, FISHERMAN_LOGO_CLASS_NAME } from './FishermanBanner.constants';
export function getBrandUrl(brand) {
  return BRAND_URLS[brand] || FISHERMAN_BRAND_URL;
}
export function getBrandLogo(brand) {
  return BRAND_SVGS[brand] || FISHERMAN_BRAND_SVG;
}
export function getBrandLogoClassName(brand) {
  return LOGO_CLASS_NAMES[brand] || FISHERMAN_LOGO_CLASS_NAME;
}